export const mountMemberChannelsArray = channels => {
  return channels
    .filter(channel => channel.staffIds.length)
    .sort(
      (c1, c2) =>
        new Date(c2.createdAt).getTime() - new Date(c1.createdAt).getTime()
    )
}
